import React, { Component } from "react";
import {
  loading,
  alert,
  NavbarAdmin,
  Modal,
  Select,
  format_date,
  GET,
  PUT,
  UPLOAD,
  t,
  can,
} from "../../components/CustomComponent.js";
import {
  EMPTY_GROUP,
  ARTICLE_TAGS,
  MEDIA_KINDS,
  MEDIA_TONES,
  ADMIN_ICON,
  clone,
  ordered,
  moveItem,
  nextSort,
  newUid,
} from "../../components/homepage_option.js";
import HomeMedia from "../homepage/components/HomeMedia.js";
import "../../assets/css/property.css";
import "../../assets/css/people.css";
import "../../assets/css/property_type.css";
import "../../assets/css/home_manage.css";
import "../../assets/css/homepage.css";

/* ============================================================================
 * จัดการหน้าแรก › บทความและความรู้  (/ad/home/articles)
 *
 * บทความที่ขึ้นหน้าแรก (แสดง 4 เรื่องเรียงแถวเดียว) — คุมหัวข้อของส่วน รายการ
 * บทความ หมวดหมู่ เวลาอ่าน ภาพปก ลำดับ และเปิด-ปิดทีละเรื่อง
 * กล่องพรีวิวใช้การ์ดชุดเดียวกับหน้าเว็บจริง (.hm-article)
 *
 * ข้อมูลอ่าน/บันทึกผ่าน API จริง
 *   GET  admin/homepage/article
 *   PUT  admin/homepage/article   (ส่ง { section, items })
 * บันทึกแบบแทนที่ทั้งชุด — จัดลำดับ/เปิด-ปิดในหน้าจอจนพอใจแล้วค่อยกดบันทึกครั้งเดียว
 * ========================================================================== */

const EMPTY_FORM = {
  tag: ARTICLE_TAGS[0].value,
  title: "",
  desc: "",
  date: "",
  read: "5",
  src: "",      // รูปปกที่อัปโหลดเอง ถ้าเว้นว่างจะใช้ภาพจำลองด้านล่าง
  kind: "abstract",
  tone: 0,
  is_active: true,
};

const isTh = () => (localStorage.getItem("lang") || "TH") !== "EN";
const locale = () => (isTh() ? "th" : "en");

/* วันที่แบบไทยย่อ เช่น 24 ก.ค. 2568 — ใช้เป็นค่าเริ่มต้นตอนเพิ่มบทความใหม่ */
const TH_MONTH = ["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."];
const todayTH = () => {
  const now = new Date();
  return `${now.getDate()} ${TH_MONTH[now.getMonth()]} ${now.getFullYear() + 543}`;
};

export default class HomeArticleSetting extends Component {
  constructor(props) {
    super(props);
    const data = clone(EMPTY_GROUP.article);
    this.state = {
      section: data.section,
      items: data.items,
      saved: clone(data),

      modal_form: false,
      edit_uid: "",
      form: { ...EMPTY_FORM },
      updated_at: "",
      updated_by: "",
    };
  }

  componentDidMount() {
    loading(false);
    this.Get();
  }

  /* โหลดเนื้อหากลุ่มนี้จากฐานข้อมูล — เรียกทั้งตอนเปิดหน้าและหลังบันทึกสำเร็จ
     เพื่อให้ uid ของรายการที่เพิ่งสร้างตรงกับฝั่ง server */
  Get = async () => {
    loading(true);
    const result = await GET("admin/homepage/article", {});
    loading(false);
    if (result?.status && result.data) this.Apply(result.data);
  };

  Apply = (data) =>
    this.setState({
      section: data.section,
      items: data.items || [],
      saved: clone({ section: data.section, items: data.items || [] }),
      updated_at: data.updated_at || "",
      updated_by: data.updated_by || "",
    });

  isDirty = () => JSON.stringify({ section: this.state.section, items: this.state.items }) !== JSON.stringify(this.state.saved);

  setSection = (patch) => this.setState((prev) => ({ section: { ...prev.section, ...patch } }));

  setForm = (patch) => this.setState((prev) => ({ form: { ...prev.form, ...patch } }));

  /* ---------------------------------------------------- เปิดฟอร์ม เพิ่ม/แก้ */
  OpenCreate = () => this.setState({ modal_form: true, edit_uid: "", form: { ...EMPTY_FORM, date: todayTH() } });

  OpenEdit = (item) =>
    this.setState({
      modal_form: true,
      edit_uid: item.uid,
      form: {
        tag: item.tag || ARTICLE_TAGS[0].value,
        title: item.title || "",
        desc: item.desc || "",
        date: item.date || "",
        read: String(item.read || 5),
        src: item.src || "",
        kind: item.kind || "abstract",
        tone: item.tone ?? 0,
        is_active: !!item.is_active,
      },
    });

  CloseForm = () => this.setState({ modal_form: false });

  /* อัปโหลดขึ้น storage ทันทีแล้วเก็บเป็น URL — ไม่เก็บ base64 ลงฐานข้อมูล
     เพราะรูปหนึ่งใบกินหลายเมกะไบต์ และทำให้ payload ตอนบันทึกใหญ่เกินจำเป็น */
  PickImage = async (event) => {
    const file = event.target.files?.[0];
    event.target.value = ""; // เลือกไฟล์เดิมซ้ำได้
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) return alert("", "warning", t("warning"), t("home_verify_image_size"));

    loading(true);
    const result = await UPLOAD(file, { folder: "homepage/article" });
    loading(false);

    if (!result?.status || !result.data?.file_path) {
      return alert("", "warning", t("warning"), result?.message || t("error_occurred"));
    }
    this.setForm({ src: result.data.file_path });
  };

  SaveArticle = () => {
    const { form, edit_uid } = this.state;
    if (!form.title.trim()) return alert("", "warning", t("warning"), t("home_verify_article_title"));
    if (!form.date.trim()) return alert("", "warning", t("warning"), t("home_verify_article_date"));

    const payload = {
      tag: form.tag,
      title: form.title.trim(),
      desc: form.desc.trim(),
      date: form.date.trim(),
      read: Number(form.read) || 1,
      src: form.src,
      kind: form.kind,
      tone: Number(form.tone),
      is_active: form.is_active,
    };

    this.setState((prev) => ({
      items: edit_uid
        ? prev.items.map((row) => (row.uid === edit_uid ? { ...row, ...payload } : row))
        : [...prev.items, { ...payload, uid: newUid("n"), sort: nextSort(prev.items) }],
      modal_form: false,
    }));
  };

  Move = (item, step) => this.setState((prev) => ({ items: moveItem(prev.items, item.uid, step) }));

  ToggleActive = (item) =>
    this.setState((prev) => ({
      items: prev.items.map((row) => (row.uid === item.uid ? { ...row, is_active: !row.is_active } : row)),
    }));

  Delete = async (item) => {
    if (!(await alert("", "warning", t("delete_item"), `${t("home_delete_article_desc")}\n${item.title}`, t("confirm"), t("cancel")))) return;
    this.setState((prev) => ({ items: prev.items.filter((row) => row.uid !== item.uid) }));
  };

  Save = async () => {
    if (!this.state.section.title.trim()) return alert("", "warning", t("warning"), t("home_verify_section_title"));
    if (!(await alert("", "info", t("confirm"), t("confirm_submission"), t("confirm"), t("cancel")))) return;

    loading(true);
    const result = await PUT("admin/homepage/article", { section: this.state.section, items: this.state.items });
    loading(false);
    if (!result?.status) return;

    this.Apply(result.data);
    alert("", "success", t("success"), t("home_save_done"));
  };

  Reset = async () => {
    if (!this.isDirty()) return;
    if (!(await alert("", "warning", t("reset_changes"), t("discard_changes_confirm"), t("confirm"), t("cancel")))) return;
    this.setState((prev) => ({ section: clone(prev.saved.section), items: clone(prev.saved.items) }));
  };

  /* ==================================================== render : รายการบทความ */
  renderList = () => {
    const list = ordered(this.state.items);
    const active = list.filter((item) => item.is_active).length;
    const dirty = this.isDirty();
    const { section } = this.state;

    return (
      <div className="prop-card prop-in">
        <div className="prop-card__head">
          <span className="prop-title text-14">
            <span className="prop-title__dot" />
            {t("home_article_list_title")}
          </span>
          <div className="hmg-sum">
            <span className="ppl-pill ppl-pill--ghost">
              {list.length} {t("home_unit_article")}
            </span>
            <span className="ppl-pill ppl-pill--on">
              <span className="ppl-pill__dot" />
              {active} {t("active")}
            </span>
            {can("homepage.update") && (
              <button type="button" className="prop-btn prop-btn--ghost" onClick={this.OpenCreate}>
                <span className="icon text-12">{ADMIN_ICON.plus}</span>
                {t("home_add_article")}
              </button>
            )}
          </div>
        </div>

        <div className="p-4 pb-2">
          <div className="row g-3">
            <div className="col-md-12">
              <label className="prop-label">
                {t("home_section_title")} <span className="text-danger">*</span>
              </label>
              <input type="text" className="prop-field" maxLength={40} value={section.title} onChange={(e) => this.setSection({ title: e.target.value })} />
            </div>
          </div>
        </div>

        <div className="hmg-list">
          {list.map((item, index) => (
            <div className={`hmg-row ${item.is_active ? "" : "is-off"}`} key={item.uid}>
              <div className="d-flex align-items-center gap-2">
                <span className="pty-rank">{index + 1}</span>
                <div className="pty-order">
                  <button type="button" className="pty-order__btn icon" title={t("ptype_move_up")} disabled={index === 0} onClick={() => this.Move(item, -1)}>
                    {ADMIN_ICON.up}
                  </button>
                  <button
                    type="button"
                    className="pty-order__btn icon"
                    title={t("ptype_move_down")}
                    disabled={index === list.length - 1}
                    onClick={() => this.Move(item, 1)}
                  >
                    {ADMIN_ICON.down}
                  </button>
                </div>
              </div>

              <div className="hmg-thumb">
                <HomeMedia src={item.src} kind={item.kind} tone={item.tone} ratio={0.66} alt={item.title} />
              </div>

              <div className="hmg-row__body">
                <div className="hmg-row__title">
                  <span>{item.title}</span>
                </div>
                <div className="hmg-row__desc">{item.desc}</div>
                <div className="hmg-row__meta">
                  <span className="hmg-tag hmg-tag--lime">{item.tag}</span>
                  <span className="hmg-tag">{item.date}</span>
                  <span className="hmg-tag">
                    <span className="icon text-10">{ADMIN_ICON.clock}</span>
                    {t("home_article_read").replace("{n}", item.read)}
                  </span>
                </div>
              </div>

              {/* เปิด/ปิด แก้ไข ลบ : ต้องมีสิทธิ์แก้ไขหน้าแรก */}
              {can("homepage.update") && (
                <div className="hmg-row__actions">
                  <label className="ppl-switch" title={item.is_active ? t("home_hide") : t("home_show")}>
                    <input type="checkbox" checked={item.is_active} onChange={() => this.ToggleActive(item)} />
                    <span className="ppl-switch__track" />
                  </label>
                  <button type="button" className="prop-iconbtn prop-iconbtn--dark icon" title={t("edit")} onClick={() => this.OpenEdit(item)}>
                    {ADMIN_ICON.edit}
                  </button>
                  <button
                    type="button"
                    className="prop-iconbtn icon"
                    style={{ borderColor: "#fecaca", color: "#b91c1c" }}
                    title={t("delete")}
                    onClick={() => this.Delete(item)}
                  >
                    {ADMIN_ICON.trash}
                  </button>
                </div>
              )}
            </div>
          ))}

          {!list.length && (
            <div className="hmg-empty">
              <span className="icon">{ADMIN_ICON.news}</span>
              {t("home_empty_article")}
            </div>
          )}
        </div>

        {/* ไม่มีสิทธิ์แก้ = ไม่ต้องมีแถบบันทึก ดูอย่างเดียว */}
        {can("homepage.update") && (
          <div className="ppl-savebar">
            {dirty ? (
              <span className="ppl-dirty">
                <span className="ppl-dirty__dot" />
                {t("unsaved_changes")}
              </span>
            ) : (
              <span className="text-secondary text-12 d-flex align-items-center gap-2">
                <span className="icon">{ADMIN_ICON.check}</span>
                {t("all_changes_saved")}
              </span>
            )}
            <div className="d-flex gap-2">
              <button type="button" className="prop-btn prop-btn--ghost" disabled={!dirty} onClick={this.Reset}>
                <span className="icon text-12">{ADMIN_ICON.reset}</span>
                {t("reset_changes")}
              </button>
              <button type="button" className="prop-btn" disabled={!dirty} onClick={this.Save}>
                <span className="icon text-12">{ADMIN_ICON.save}</span>
                {t("save_settings")}
              </button>
            </div>
          </div>
        )}
      </div>
    );
  };

  /* ==================================================== render : กล่องพรีวิว */
  renderPreview = () => {
    const { section } = this.state;
    const list = ordered(this.state.items).filter((item) => item.is_active);

    return (
      <div className="prop-card prop-in hmg-preview">
        <div className="prop-card__head">
          <span className="prop-title text-14">
            <span className="prop-title__dot" />
            {t("home_preview")}
          </span>
          <a className="prop-link" href="/" target="_blank" rel="noreferrer">
            <span className="icon text-12">{ADMIN_ICON.external}</span>
            {t("home_open_site")}
          </a>
        </div>

        <div className="p-3">
          <div className="hmg-frame">
            <div className="hmg-frame__bar">
              <span className="hmg-frame__dot" />
              <span className="hmg-frame__dot" />
              <span className="hmg-frame__dot" />
              <span className="hmg-frame__url">safespacelifeliving.com/#articles</span>
            </div>
            <div className="hmg-frame__body">
              <div className="mn-home">
                <div className="hm-section__head" style={{ marginBottom: "14px" }}>
                  <div>
                    <h2 className="hm-section__title" style={{ fontSize: "18px" }}>
                      {section.title}
                    </h2>
                  </div>
                </div>

                {/* หน้าเว็บจริงวางการ์ด 4 ใบเรียงแถวเดียว กล่องพรีวิวแคบกว่า
                    จึงเรียงลงเป็นคอลัมน์เดียว แต่ตัวการ์ดยังเป็นภาพซ้าย-ข้อความขวาเหมือนกัน */}
                <div className="hm-grid" style={{ gridTemplateColumns: "minmax(0, 1fr)", gap: "12px" }}>
                  {list.slice(0, 4).map((item) => (
                    <article className="hm-article" key={item.uid} style={{ gridTemplateColumns: "96px minmax(0, 1fr)" }}>
                      <div className="hm-article__media">
                        <HomeMedia src={item.src} kind={item.kind} tone={item.tone} ratio={1} alt={item.title} />
                        <span className="hm-badge hm-badge--light hm-article__tag">{item.tag}</span>
                      </div>
                      <div className="hm-article__body" style={{ padding: "12px 14px", gap: "6px" }}>
                        <h3 className="hm-article__title" style={{ fontSize: "13px" }}>
                          {item.title}
                        </h3>
                        <span className="hm-article__more" style={{ fontSize: "11.5px" }}>
                          {t("home_article_more")}
                        </span>
                      </div>
                    </article>
                  ))}
                </div>

                {!list.length && <div className="hmg-empty">{t("home_empty_article")}</div>}
              </div>
            </div>
          </div>

          <div className="ppl-note mt-3">
            <span className="icon">{ADMIN_ICON.info}</span>
            <div>{t("home_article_preview_hint")}</div>
          </div>
        </div>
      </div>
    );
  };

  /* ================================================== render : ฟอร์มเพิ่ม/แก้ */
  renderFormModal = () => {
    const { modal_form, edit_uid, form } = this.state;

    return (
      <Modal show={modal_form} onHide={this.CloseForm} size="lg" centered>
        <Modal.Header className="border-bottom border-light px-4 py-3 bg-white">
          <div>
            <h5 className="fw-bold mb-0 text-dark">{edit_uid ? t("home_edit_article") : t("home_add_article")}</h5>
            <div className="text-secondary text-12">{t("home_article_form_desc")}</div>
          </div>
        </Modal.Header>

        <Modal.Body className="p-4 bg-white">
          {/* ตัวอย่างการ์ดจริง */}
          <div className="mn-home mb-4">
            <article className="hm-article" style={{ maxWidth: "440px", gridTemplateColumns: "120px minmax(0, 1fr)" }}>
              <div className="hm-article__media">
                <HomeMedia src={form.src} kind={form.kind} tone={Number(form.tone)} ratio={1} />
                <span className="hm-badge hm-badge--light hm-article__tag">{form.tag}</span>
              </div>
              <div className="hm-article__body" style={{ padding: "12px 14px" }}>
                {/* วันที่/เวลาอ่าน ไม่ได้แสดงบนการ์ดหน้าเว็บแล้ว แต่ยังเก็บไว้ใช้กับ
                    หน้ารายละเอียดบทความ จึงโชว์ในตัวอย่างฟอร์มให้ผู้ดูแลเห็นค่าที่กรอก */}
                <div className="hm-article__meta" style={{ fontSize: "11px" }}>
                  <span>{form.date || todayTH()}</span>
                  <span>•</span>
                  <span>{t("home_article_read").replace("{n}", form.read || 0)}</span>
                </div>
                <h3 className="hm-article__title" style={{ fontSize: "14px" }}>
                  {form.title || t("home_article_placeholder_title")}
                </h3>
                <span className="hm-article__more" style={{ fontSize: "11.5px" }}>
                  {t("home_article_more")}
                </span>
              </div>
            </article>
          </div>

          <div className="row g-3">
            <div className="col-12">
              <label className="prop-label">
                {t("home_article_title")} <span className="text-danger">*</span>
              </label>
              <input type="text" className="prop-field" maxLength={90} value={form.title} onChange={(e) => this.setForm({ title: e.target.value })} />
            </div>

            <div className="col-12">
              <label className="prop-label">{t("home_article_desc")}</label>
              <textarea
                className="prop-field"
                rows={2}
                style={{ height: "auto", paddingTop: "10px" }}
                maxLength={160}
                value={form.desc}
                onChange={(e) => this.setForm({ desc: e.target.value })}
              />
            </div>

            <div className="col-md-4">
              <label className="prop-label">{t("home_article_tag")}</label>
              <Select
                className="prop-field prop-select"
                default={false}
                placeholder={t("select")}
                value={form.tag}
                options={ARTICLE_TAGS}
                onChange={(value) => value && this.setForm({ tag: value })}
              />
            </div>

            <div className="col-md-4">
              <label className="prop-label">
                {t("home_article_date")} <span className="text-danger">*</span>
              </label>
              <input type="text" className="prop-field" maxLength={20} placeholder={todayTH()} value={form.date} onChange={(e) => this.setForm({ date: e.target.value })} />
            </div>

            <div className="col-md-4">
              <label className="prop-label">{t("home_article_read_label")}</label>
              <div className="set-affix">
                <input
                  type="text"
                  className="prop-field"
                  maxLength={2}
                  value={form.read}
                  onChange={(e) => /^\d*$/.test(e.target.value) && this.setForm({ read: e.target.value })}
                />
                <span className="set-affix__unit">{t("home_unit_minute")}</span>
              </div>
            </div>

            {/* ภาพปก : อัปโหลดรูปเอง หรือใช้ภาพจำลองไปก่อน */}
            <div className="col-md-5">
              <label className="prop-label">{t("home_article_image")}</label>
              <label className={`hmg-drop ${form.src ? "has-image" : ""}`}>
                <input type="file" accept="image/*" onChange={this.PickImage} />
                {form.src && <img src={form.src} alt="cover" />}
                <span className="hmg-drop__tip">
                  <span className="icon">{ADMIN_ICON.photo}</span>
                  {form.src ? t("change_image") : t("home_pick_image")}
                </span>
              </label>
              <div className="ppl-sub mt-1">{t("home_article_image_hint")}</div>
              {!!form.src && (
                <button type="button" className="prop-link mt-2" onClick={() => this.setForm({ src: "" })}>
                  <span className="icon text-12">{ADMIN_ICON.trash}</span>
                  {t("home_remove_image")}
                </button>
              )}
            </div>

            <div className="col-md-7">
              <label className="prop-label">{t("home_article_cover")}</label>
              <div className="hmg-picker">
                {MEDIA_KINDS.map((item) => (
                  <button key={item.value} type="button" className={`hmg-picker__kind ${form.kind === item.value ? "is-on" : ""}`} onClick={() => this.setForm({ kind: item.value })}>
                    {t(item.label)}
                  </button>
                ))}
              </div>
              <div className="ppl-sub mt-2">{form.src ? t("home_scene_ignored") : t("home_scene_hint")}</div>
            </div>

            <div className="col-md-4">
              <label className="prop-label">{t("status")}</label>
              <div className="d-flex align-items-center gap-2" style={{ height: "44px" }}>
                <label className="ppl-switch">
                  <input type="checkbox" checked={form.is_active} onChange={(e) => this.setForm({ is_active: e.target.checked })} />
                  <span className="ppl-switch__track" />
                </label>
                <span className={`text-12 fw-bold ${form.is_active ? "text-success" : "text-secondary"}`}>
                  {form.is_active ? t("home_show") : t("home_hide")}
                </span>
              </div>
            </div>

            <div className="col-12">
              <label className="prop-label">{t("home_scene_tone")}</label>
              <div className="hmg-picker">
                {MEDIA_TONES.map((tone) => (
                  <button
                    key={tone}
                    type="button"
                    className={`hmg-picker__tone ${Number(form.tone) === tone ? "is-on" : ""}`}
                    title={`${t("home_scene_tone")} ${tone + 1}`}
                    onClick={() => this.setForm({ tone })}
                  >
                    <HomeMedia kind={form.kind} tone={tone} ratio={0.7} />
                  </button>
                ))}
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-end gap-2">
          <button type="button" className="prop-btn prop-btn--ghost" onClick={this.CloseForm}>
            {t("cancel")}
          </button>
          <button type="button" className="prop-btn" onClick={this.SaveArticle}>
            <span className="icon text-12">{ADMIN_ICON.check}</span>
            {t("confirm")}
          </button>
        </Modal.Footer>
      </Modal>
    );
  };

  render() {
    const { updated_at, updated_by } = this.state;

    return (
      <div className="w-100 min-vh-100 prop-page">
        <NavbarAdmin />
        <div className="body p-4">
          <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3 prop-in">
            <div>
              <h3 className="fw-bold mb-1 text-dark">{t("home_article_manage")}</h3>
              <div className="text-secondary text-14">{t("home_article_manage_desc")}</div>
            </div>
            <div className="text-secondary text-12 text-lg-end">
              <div>
                {t("updated")} {format_date(updated_at, "dd mmm yyyy hh:mm", locale())}
              </div>
              <div>
                {t("updated_by")} {updated_by}
              </div>
            </div>
          </div>

          <div className="row g-3">
            <div className="col-xl-7 col-lg-7">{this.renderList()}</div>
            <div className="col-xl-5 col-lg-5">{this.renderPreview()}</div>
          </div>
        </div>

        {this.renderFormModal()}
      </div>
    );
  }
}
